import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { LeafletMapComponent, BasemapDescriptor, VectorLayerDescriptor,OneTimeSplashComponent,
         TourConfig, Tour, TourService } from 'map-wald-leaflet';
import { DisplaySettings } from '../data';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

const OPACITY_STEP = 0.4;

@Component({
  selector: 'app-map-buttons',
  templateUrl: './map-buttons.component.html',
  styleUrls: ['./map-buttons.component.scss']
})
export class MapButtonsComponent implements OnInit, OnChanges {
  // @Input() vectorLayers: VectorLayerDescriptor[];
  // @Input() basemaps: BasemapDescriptor[];
  @Input() helpModal: OneTimeSplashComponent;
  @Input() feedbackAddress: string;
  @Output() optionsChanged = new EventEmitter<DisplaySettings>();
  @Input() minZoom = 5;
  @Input() maxZoom = 16;
  @Input() hintPlacement = 'left';
  @Input() orientation = 'vertical';
  @Output() shareView = new EventEmitter<void>();
  @Output() tourStarted = new EventEmitter<Tour>();
  @Output() downloadMap = new EventEmitter<void>();

  @ViewChild('popRef',{static:false}) toursPopover: any;
  @ViewChild('feedbackPopup',{static:false}) feedbackPopup: any;
  private vp: any;

  tours: TourConfig[];
  addressCopied = false;
  currentZoom: number;
  transparency = 0;
  opacity = 1;
  showWindows = true;
  zoom = 9;
  mainLayer: any;
  basemapIdx = 0;
  baseLayer: BasemapDescriptor;

  constructor(private map: LeafletMapComponent,
              private modalService:NgbModal,
              private tourService:TourService) {

    this.tourService.tours$.subscribe(tours=>{
      this.tours = tours;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if(changes.basemaps&&this.basemaps&&!this.baseLayer){
    //   this.baseLayer = this.basemaps[0];
    // }
  }

  ngOnInit(): void {
    this.withMap(m=>{
      this.zoom = m.getZoom();
      m.on('zoom',()=>{
        this.zoom = m.getZoom();
      });
    });
  }

  zoomIn(): void {
    this.withMap(m=>m.setZoom(m.getZoom()+1));
  }

  zoomOut(): void {
    this.withMap(m=>m.setZoom(m.getZoom()-1));
  }

  zoomToFit(): void {
    this.optionsChanged.emit({
      resetBounds: true
    });
  }

  toggleTransparency(): void {
    this.opacity -= OPACITY_STEP;
    if(this.opacity <= 0.0) {
      this.opacity = 1.0;
    }
    this.optionsChanged.emit({
      opacity:this.opacity
    });
    this.transparency = (1-this.opacity)*100;
  }

  transparencyChanged(): void {
    this.opacity = 1- (this.transparency/100);
    this.optionsChanged.emit({
      opacity:this.opacity
    });
  }

  // toggleBaseLayer(): void {
  //   this.setBaseLayer((this.basemapIdx+1)%this.basemaps.length);
  // }

  // setBaseLayer(idx: number): void {
  //   this.basemapIdx = idx;
  //   this.baseLayer = this.basemaps[this.basemapIdx];

  //   this.optionsChanged.emit({
  //     basemap:this.baseLayer
  //   });
  // }

  toggleButtons(): void {
    this.showWindows = !this.showWindows;
    this.optionsChanged.emit({
      showWindows: this.showWindows
    });
  }

  withMap(fn:((m:L.Map)=>void)): void {
    this.map.withMap(fn);
  }

  vectorLayerChanged(v: VectorLayerDescriptor): void {
    this.optionsChanged.emit({
      vectorLayer: v
    });
  }

  mailtoClicked(): void {
    const timer = setTimeout(() => {
      this.addressCopied = false;
      this.modalService.open(this.feedbackPopup,{
        size:'lg'
      });
      window.onblur = null;
    },1000);

    window.onblur =() => {
      clearTimeout(timer);
      window.onblur = null;
    };
  }

  copyAddress(): void {
    navigator.clipboard.writeText(this.feedbackAddress).then(()=>{
      this.addressCopied = true;
      // alert('Please email us at ' + this.feedbackAddress);
    });
  }

  _tourStarted(tour:Tour):void {
    this.toursPopover.close();
    this.tourStarted.emit(tour);
  }
}

